export const _myInterestsList = [
  {
    question: 'Que tipo de conteúdo você consome nas redes sociais?',
    options: [
      {
        image: '/assets/images/my-interests/img-1.png',
        name: 'Decoração de ambientes e DIY',
      },
      {
        image: '/assets/images/my-interests/img-2.png',
        name: 'Cuidados paternos, maternos e do mundo infantil',
      },
      {
        image: '/assets/images/my-interests/img-3.png',
        name: 'Bem-estar, academia e vida saudável',
      },
      {
        image: '/assets/images/my-interests/img-4.png',
        name: 'Filmes, livros, séries e entretenimento em geral',
      },
      {
        image: '/assets/images/my-interests/img-5.png',
        name: 'Moda e estilo',
      },
      {
        image: '/assets/images/my-interests/img-6.png',
        name: 'Comer e beber: dicas de restaurantes e receitas',
      },
    ],
  },
  {
    question: 'O que mais gosta de fazer no seu tempo livre?',
    options: [
      {
        image: '/assets/images/my-interests/img-7.png',
        name: 'Conhecer novos restaurantes',
      },
      {
        image: '/assets/images/my-interests/img-8.png',
        name: 'Jogar videogame',
      },
      {
        image: '/assets/images/my-interests/img-9.png',
        name: 'Passear com a família',
      },
      {
        image: '/assets/images/my-interests/img-10.png',
        name: 'Decorar ou criar novos ambientes',
      },
      {
        image: '/assets/images/my-interests/img-11.png',
        name: 'Praticar esportes',
      },
      {
        image: '/assets/images/my-interests/img-12.png',
        name: 'Ter um momento de autocuidado',
      },
    ],
  },
  {
    question: 'O que você costuma comprar quando vai ao shopping?',
    options: [
      {
        image: '/assets/images/my-interests/img-13.png',
        name: 'Itens de casa e decoração',
      },
      {
        image: '/assets/images/my-interests/img-14.png',
        name: 'Itens infantis',
      },
      {
        image: '/assets/images/my-interests/img-15.png',
        name: 'Vinhos e especiarias',
      },
      {
        image: '/assets/images/my-interests/img-16.png',
        name: 'Suplementos e acessórios esportivos',
      },
      {
        image: '/assets/images/my-interests/img-17.png',
        name: 'Objetos de personagens favoritos',
      },
      {
        image: '/assets/images/my-interests/img-18.png',
        name: 'Roupas e calçados',
      },
    ],
  },
  {
    question: 'O que não pode faltar na sua lista de desejos?',
    options: [
      {
        image: '/assets/images/my-interests/img-19.png',
        name: 'Eletrônicos de última geração',
      },
      {
        image: '/assets/images/my-interests/img-20.png',
        name: 'Maquiagem e perfumaria',
      },
      {
        image: '/assets/images/my-interests/img-21.png',
        name: 'Móveis e acessórios para decoração e construção',
      },
      {
        image: '/assets/images/my-interests/img-22.png',
        name: 'Moda e literatura infantil',
      },
      {
        image: '/assets/images/my-interests/img-23.png',
        name: 'Moda esportiva',
      },
      {
        image: '/assets/images/my-interests/img-24.png',
        name: 'Restaurantes, cafeteria e sobremesas',
      },
    ],
  },
  {
    question: 'Em qual desses eventos sua presença estaria garantida?',
    options: [
      {
        image: '/assets/images/my-interests/img-25.png',
        name: 'Feira gastronômica',
      },
      {
        image: '/assets/images/my-interests/img-26.png',
        name: 'Eventos e feiras multiesportivas',
      },
      {
        image: '/assets/images/my-interests/img-27.png',
        name: 'Decoração de Natal',
      },
      {
        image: '/assets/images/my-interests/img-28.png',
        name: 'Exposições ou feiras de casa e decoração',
      },
      {
        image: '/assets/images/my-interests/img-29.png',
        name: 'Eventos gamers e inovação e tecnologia',
      },
      {
        image: '/assets/images/my-interests/img-30.png',
        name: 'Desfile da sua marca favorita',
      },
    ],
  },
];

export const _myInterests = {
  primaryResult: {
    image: '/assets/images/my-interests/primary-interest.png',
    name: 'Cultura e entretenimento',
  },
  secondaryResult: {
    image: '/assets/images/my-interests/secondary-interest.png',
    name: 'Culinária e degustação',
  },
};
